var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-empty',{attrs:{"description":"404"}},[_c('el-button',{attrs:{"type":"primary","round":"","size":"small"},on:{"click":_vm.goBack}},[_vm._v("返回上一页")]),_c('el-button',{attrs:{"type":"danger","round":"","size":"small"},on:{"click":_vm.logOut}},[_vm._v("退出登录")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }